import { lazy } from 'react'
import { Navigate, useRoutes } from 'react-router-dom'
import { retry } from '../common/utils/CommonFunctions'
import { useAuthContext } from '../hooks/useAuthContext'

const Login = lazy(() => retry(() => import('../pages/Login')))
const FourOhFour = lazy(() => retry(() => import('../pages/FourOhFour')))
const DeleteAccount = lazy(() => retry(() => import('../pages/DeleteAccount')))
const PageUnderConstruction = lazy(() =>
  retry(() => import('../pages/PageUnderConstruction')),
)
const Sidebar = lazy(() => retry(() => import('../layout/Sidebar')))

const Routes = () => {
  const { token } = useAuthContext()

  const routes = useRoutes([
    {
      path: '/',
      element: <Navigate replace to="/admin/dashboard" />,
    },
    {
      path: '/admin/*',
      element: token ? <Sidebar /> : <Navigate replace to="/admin/login" />,
    },
    {
      path: '/admin/login',
      element: !token ? <Login /> : <Navigate replace to="/admin/dashboard" />,
    },
    {
      path: '/admin',
      element: <Navigate replace to="/admin/login" />,
    },
    {
      path: '/*',
      element: <Navigate replace to="/404" />,
    },
    {
      path: '/404',
      element: <FourOhFour />,
    },
    {
      path: '/503',
      element: <PageUnderConstruction />,
    },
    {
      path: '/delete-account',
      element: <DeleteAccount />,
    },
  ])

  return routes
}

export default Routes
